<script setup lang="ts">
// Material Symbols `done_all` — the double tick the design sets inside the
// wizard's completion medallion. PrimeIcons has no double-check glyph at all, so
// this is the only way to render it (Figma 20012:163322).
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg viewBox="0 0 30 30" fill="currentColor" xmlns="http://www.w3.org/2000/svg" v-bind="$attrs">
    <path
      d="M8.375 22.0672L1.74531 15.4375L3.08187 14.1203L8.39437 19.4328L8.82688 19L10.1444 20.3172L8.375 22.0672ZM15.4375 22.0672L8.80781 15.4375L10.125 14.1009L15.4375 19.4134L26.9375 7.91344L28.2547 9.25L15.4375 22.0672ZM15.0047 15.4375L13.6681 14.1203L19.8556 7.93281L21.1922 9.25L15.0047 15.4375Z"
    />
  </svg>
</template>
